import React, { useEffect } from "react";
import "./App.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Header from "./Header";
import PropTypes from "prop-types";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString().substr(-2);
  return `${day}/${month}/${year}`;
};

const FeeReceiptUI = ({ receiptData, isLoading, sendEReceipt }) => {
  useEffect(() => {
    if (sendEReceipt && receiptData?.email && receiptData?.transaction_id) {
      sendEReceipt(receiptData);
    }
  }, [receiptData, sendEReceipt]);

  const handleDownload = () => {
    if (!receiptData) {
      console.error("Receipt data unavailable.");
      return;
    }

    const receipt = document.querySelector(".receipt-container");
    if (!receipt) {
      console.error("Receipt container not found.");
      return;
    }

    html2canvas(receipt, { scale: 2, useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const ratio = Math.min(
        pdf.internal.pageSize.getWidth() / canvas.width,
        pdf.internal.pageSize.getHeight() / canvas.height
      );

      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        canvas.width * ratio,
        canvas.height * ratio
      );

      const pdfBlob = pdf.output("blob");
      pdf.save(`${receiptData.transaction_id}_Receipt.pdf`);
    });
  };

  const tableData = [
    { label: "Student Name", value: receiptData?.studentName },
    { label: "Admission Number", value: receiptData?.admissionNumber },
    { label: "Parent's Name", value: receiptData?.fathersName },
    { label: "Email", value: receiptData?.email },
    { label: "Year", value: receiptData?.year },
    { label: "DOB", value: formatDate(receiptData?.dob) },
    { label: "Course", value: receiptData?.course },
    { label: "Mobile Number", value: receiptData?.mobile },
    { label: "Tution Fees", value: receiptData?.tutionFees },
  ];

  return (
    <div>
      <Header />
      <div className="receipt-container">
        {isLoading ? (
          <p>Loading...</p>
        ) : receiptData ? (
          <>
            <h1 className="fee-receipt">Fee Receipt</h1>
            <h2 className="college-name">LADY IRWIN COLLEGE</h2>

            <div className="contact-info">
              <p><strong>Address: UNIVERSITY OF DELHI, SIKANDRA RD, MANDI HOUSE, NEW DELHI, DELHI 110001</strong></p>
              <p><strong>Phone: +91-11-23711222 | +91 11 2371 9859</strong></p>
              <p><strong>Email: <a href="mailto:accountoffice@lic.du.ac.in">accountoffice@lic.du.ac.in</a></strong> | <strong>Website: <a href="https://ladyirwin.edu.in/">"https://ladyirwin.edu.in/"</a></strong></p>               
            </div>

            <div className="receipt-details">
              <div>
                <p><strong>Receipt No: </strong> {receiptData.receipt_no}</p>
                <p><strong>Date: </strong>{formatDate(receiptData.transaction_date)}</p>
              </div>
              <div>
                <p><strong>Received from: </strong> {receiptData.studentName}</p>
                <p><strong>Transaction ID: </strong>{receiptData.transaction_id}</p>
              </div>
            </div>

            <div className="card">
              <h3>Fee Details</h3>
              <table className="student-table">
                <tbody>
                  {tableData.map((item, index) => (
                    <tr key={index}>
                      <td><strong>{item.label}</strong></td>
                      <td>{item.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <p>No data found!</p>
        )}
      </div>
      <div className="button-container">
        <button className="action-btn" onClick={handleDownload}>Download</button>
      </div>
    </div>
  );
};

FeeReceiptUI.propTypes = {
  receiptData: PropTypes.shape({
    receipt_no: PropTypes.string,
    transaction_date: PropTypes.string,
    studentName: PropTypes.string,
    admissionNumber: PropTypes.string,
    fathersName: PropTypes.string,
    email: PropTypes.string,
    year: PropTypes.string,
    dob: PropTypes.string,
    course: PropTypes.string,
    mobile: PropTypes.string,
    tutionFees: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    transaction_id: PropTypes.string,
  }),
  isLoading: PropTypes.bool.isRequired,
  sendEReceipt: PropTypes.func,
};

export default FeeReceiptUI;

